module.exports = __webpack_public_path__ + "media/games-24.91960fd2.mp4";